import React from 'react';

import LottieView from 'components/lottie-animations/lottie-view';

export const DesktopAnimation: React.FC = () => {
  return (
    <LottieView
      source={desktopAnimationConfig}
      autoPlay
      loop
      animationDelay={100}
      style={{
        alignSelf: 'center',
        width: '50%',
      }}
      resizeMode="cover"
    />
  );
};

const desktopAnimationConfig = {
  v: '5.7.1',
  fr: 29.9700012207031,
  ip: 1.00000004073083,
  op: 70.0000028511585,
  w: 960,
  h: 540,
  nm: 'logo_simple',
  ddd: 0,
  assets: [],
  fonts: {
    list: [
      {
        fName: 'BlockPro-Condensed',
        fFamily: 'Block Pro',
        fStyle: 'Condensed',
        ascent: 71.099853515625,
      },
    ],
  },
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 5,
      nm: '®',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 43,
              s: [0],
            },
            {
              t: 44.0000017921567,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [624.25, 435.75, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 14,
                f: 'BlockPro-Condensed',
                t: '®',
                j: 2,
                tr: 0,
                lh: 16.8,
                ls: 0,
                fc: [0.839, 0.141, 0],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {
          g: 1,
          a: {
            a: 0,
            k: [0, 0],
            ix: 2,
          },
        },
        a: [],
      },
      ip: 0,
      op: 300.00001221925,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Bun Top inside',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 34,
              s: [0],
            },
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 35,
              s: [99],
            },
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 39,
              s: [100],
            },
            {
              t: 40.0000016292334,
              s: [0],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [490.5, 155.5, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [129.5, 101.5, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 35,
                    s: [
                      {
                        i: [
                          [-0.062, -19.438],
                          [62.724, 0],
                          [28.708, 15.438],
                          [-37.135, 0.652],
                        ],
                        o: [
                          [-22.438, 16.438],
                          [-62.725, 0],
                          [-0.792, -20.562],
                          [37.135, -0.652],
                        ],
                        v: [
                          [141.073, -41],
                          [0, -17.34],
                          [-141.073, -41],
                          [0, -78.91],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 39.0000015885026,
                    s: [
                      {
                        i: [
                          [-0.062, -2.813],
                          [62.724, 0],
                          [0.042, 3.812],
                          [-37.135, 0.652],
                        ],
                        o: [
                          [0.062, 2.813],
                          [-62.725, 0],
                          [-0.042, -3.812],
                          [37.136, -0.652],
                        ],
                        v: [
                          [141.073, 46.5],
                          [0, 50.16],
                          [-141.073, 46.5],
                          [0, 42.09],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.874509803922, 0.662745098039, 0.262745098039, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [126.365, 100.562],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 300.00001221925,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Bun Bottom inside',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 8,
              s: [0],
            },
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 9,
              s: [100],
            },
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 13,
              s: [100],
            },
            {
              t: 14.0000005702317,
              s: [0],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [493.5, 347.5, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [129.5, 101.5, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [50, 50, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 9,
                    s: [
                      {
                        i: [
                          [0, -45.79],
                          [62.724, 0],
                          [0, 45.79],
                          [-62.725, 0],
                        ],
                        o: [
                          [0, 45.79],
                          [-62.725, 0],
                          [0, -45.79],
                          [62.724, 0],
                        ],
                        v: [
                          [113.573, 0],
                          [0, 82.91],
                          [-113.573, 0],
                          [0, -82.91],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 11,
                    s: [
                      {
                        i: [
                          [-0.722, -28.896],
                          [62.724, 0],
                          [-0.396, 21.719],
                          [-51.719, -1.014],
                        ],
                        o: [
                          [0.539, 21.549],
                          [-62.725, 0],
                          [0.59, -32.396],
                          [51.719, 1.014],
                        ],
                        v: [
                          [221.358, -229.167],
                          [-5.5, -195.59],
                          [-232.455, -229.167],
                          [-5.583, -266.577],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 12,
                    s: [
                      {
                        i: [
                          [0.115, -9.438],
                          [62.724, 0],
                          [-0.219, 9.688],
                          [-62.725, 0],
                        ],
                        o: [
                          [-0.115, 9.438],
                          [-62.725, 0],
                          [0.233, -10.314],
                          [62.724, 0],
                        ],
                        v: [
                          [275.25, -343.75],
                          [-8.25, -334.84],
                          [-291.896, -343.75],
                          [-8.375, -356.16],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 13.0000005295009,
                    s: [
                      {
                        i: [
                          [0.115, -9.438],
                          [62.724, 0],
                          [-0.219, 9.688],
                          [-62.725, 0],
                        ],
                        o: [
                          [-0.115, 9.438],
                          [-62.725, 0],
                          [0.233, -10.314],
                          [62.724, 0],
                        ],
                        v: [
                          [275.25, -343.75],
                          [-8.25, -334.84],
                          [-291.896, -343.75],
                          [-8.375, -356.16],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.874509803922, 0.662745098039, 0.262745098039, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [126.365, 100.562],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 300.00001221925,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'Text Burger',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 32,
              s: [0],
            },
            {
              t: 33.0000013441176,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 33,
              s: [490, 97, 0],
              to: [0, 31.333, 0],
              ti: [0, -31.333, 0],
            },
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 35,
              s: [490, 285, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 37,
              s: [490, 285, 0],
              to: [0, 1.167, 0],
              ti: [0, 1, 0],
            },
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 40,
              s: [490, 292, 0],
              to: [0, -1, 0],
              ti: [0, 2.167, 0],
            },
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 43,
              s: [490, 279, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              t: 45.0000018328876,
              s: [490, 279, 0],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [319, 334, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [53, 53, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.318, 0],
                    [0, 0],
                    [0, 2.265],
                    [0, 0],
                    [-2.96, 0],
                    [0, 0],
                    [0, -4.529],
                  ],
                  o: [
                    [0, 0],
                    [-2.96, 0],
                    [0, 0],
                    [0, -2.264],
                    [0, 0],
                    [7.318, 0],
                    [0, 4.366],
                  ],
                  v: [
                    [-3.049, -8.891],
                    [-5.49, -8.891],
                    [-9.849, -12.901],
                    [-9.849, -24.755],
                    [-5.49, -28.766],
                    [-3.049, -28.766],
                    [6.534, -19.005],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [3.138, 4.003],
                    [2.265, 6.105],
                    [-1.569, 1.221],
                    [0, 14.643],
                    [22.139, 0],
                    [0, 0],
                    [0, -10.811],
                    [0, 0],
                    [-11.158, 0],
                    [0, 10.456],
                    [0, 0],
                    [-1.738, 0],
                    [-0.348, -2.094],
                    [-4.706, -6.104],
                    [-5.579, 0],
                    [0, 8.895],
                  ],
                  o: [
                    [-5.927, -7.503],
                    [-0.525, -1.391],
                    [5.402, -4.188],
                    [0, -22.147],
                    [0, 0],
                    [-13.777, 0],
                    [0, 0],
                    [0, 10.456],
                    [11.159, 0],
                    [0, 0],
                    [0, -2.264],
                    [2.094, 0],
                    [1.568, 8.894],
                    [5.927, 7.844],
                    [9.064, 0],
                    [0, -5.927],
                  ],
                  v: [
                    [36.872, 27.375],
                    [25.017, 8.891],
                    [26.416, 5.058],
                    [38.093, -23.008],
                    [-2.353, -57.705],
                    [-22.051, -57.705],
                    [-42.451, -38.873],
                    [-42.451, 38.881],
                    [-25.188, 57.706],
                    [-7.932, 38.881],
                    [-7.932, 20.397],
                    [-5.143, 17.082],
                    [-2.005, 20.397],
                    [8.458, 47.42],
                    [25.543, 57.706],
                    [42.451, 41.663],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [543.549, 277.525],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.318, 0],
                    [0, 0],
                    [0, 2.265],
                    [0, 0],
                    [-2.959, 0],
                    [0, 0],
                    [0, -4.529],
                  ],
                  o: [
                    [0, 0],
                    [-2.959, 0],
                    [0, 0],
                    [0, -2.264],
                    [0, 0],
                    [7.318, 0],
                    [0, 4.366],
                  ],
                  v: [
                    [-3.049, -8.891],
                    [-5.491, -8.891],
                    [-9.849, -12.901],
                    [-9.849, -24.755],
                    [-5.491, -28.766],
                    [-3.049, -28.766],
                    [6.533, -19.005],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [3.138, 4.003],
                    [2.264, 6.105],
                    [-1.569, 1.221],
                    [0, 14.643],
                    [22.147, 0],
                    [0, 0],
                    [0, -10.811],
                    [0, 0],
                    [-11.158, 0],
                    [0, 10.456],
                    [0, 0],
                    [-1.739, 0],
                    [-0.348, -2.094],
                    [-4.706, -6.104],
                    [-5.579, 0],
                    [0, 8.895],
                  ],
                  o: [
                    [-5.054, -6.63],
                    [-0.525, -1.391],
                    [5.401, -4.188],
                    [0, -22.147],
                    [0, 0],
                    [-13.778, 0],
                    [0, 0],
                    [0, 10.456],
                    [11.16, 0],
                    [0, 0],
                    [0, -2.264],
                    [2.094, 0],
                    [1.569, 8.894],
                    [5.928, 7.844],
                    [9.064, 0],
                    [0, -5.927],
                  ],
                  v: [
                    [36.871, 27.375],
                    [25.017, 8.891],
                    [26.416, 5.058],
                    [38.093, -23.008],
                    [-2.354, -57.705],
                    [-22.051, -57.705],
                    [-42.451, -38.873],
                    [-42.451, 38.881],
                    [-25.189, 57.706],
                    [-7.933, 38.881],
                    [-7.933, 20.397],
                    [-5.143, 17.082],
                    [-2.006, 20.397],
                    [8.457, 47.42],
                    [25.543, 57.706],
                    [42.451, 41.663],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [273.156, 277.525],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [8.369, 0],
                    [0, 0],
                    [0, 2.272],
                    [0, 0],
                    [-2.967, 0],
                    [0, 0],
                    [0, -5.054],
                  ],
                  o: [
                    [0, 0],
                    [-2.967, 0],
                    [0, 0],
                    [0, -2.272],
                    [0, 0],
                    [8.369, 0],
                    [0, 4.529],
                  ],
                  v: [
                    [-2.964, 31.118],
                    [-6.101, 31.118],
                    [-10.459, 27.108],
                    [-10.459, 13.516],
                    [-6.101, 9.505],
                    [-2.964, 9.505],
                    [7.848, 20.138],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-2.967, 0],
                    [0, 0],
                    [0, -4.535],
                    [7.503, 0],
                    [0, 0],
                    [0, 2.264],
                  ],
                  o: [
                    [0, -2.272],
                    [0, 0],
                    [7.503, 0],
                    [0, 4.181],
                    [0, 0],
                    [-2.967, 0],
                    [0, 0],
                  ],
                  v: [
                    [-10.459, -27.278],
                    [-6.101, -31.289],
                    [-3.837, -31.289],
                    [5.931, -21.529],
                    [-3.837, -11.421],
                    [-6.101, -11.421],
                    [-10.459, -15.424],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 2,
              ty: 'sh',
              ix: 3,
              ks: {
                a: 0,
                k: {
                  i: [
                    [2.095, 1.739],
                    [0, 0.695],
                    [-0.865, 1.044],
                    [0, 8.894],
                    [21.97, 0],
                    [0, 0],
                    [0, -10.811],
                    [0, 0],
                    [-13.771, 0],
                    [0, 0],
                    [0, 19.35],
                  ],
                  o: [
                    [-0.865, -0.703],
                    [0, -0.873],
                    [3.315, -3.84],
                    [0, -20.919],
                    [0, 0],
                    [-13.771, 0],
                    [0, 0],
                    [0, 10.803],
                    [0, 0],
                    [23.182, 0],
                    [0, -15.516],
                  ],
                  v: [
                    [29.808, -2.001],
                    [28.07, -4.095],
                    [29.461, -6.36],
                    [36.084, -25.191],
                    [-0.004, -57.268],
                    [-20.744, -57.268],
                    [-41.145, -38.436],
                    [-41.145, 38.445],
                    [-20.744, 57.269],
                    [3.837, 57.269],
                    [41.145, 22.402],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 3',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [83.917, 277.088],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 3',
          np: 5,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-7.318, -5.402],
                    [0, -5.927],
                    [9.243, 0],
                    [11.514, 0],
                    [0, -19.179],
                    [-13.075, 0],
                    [0, 3.145],
                    [3.316, 0],
                    [0, 9.76],
                    [-10.286, 0],
                    [0, 0],
                    [0, -16.212],
                    [27.37, 0],
                    [0, 39.403],
                    [-27.024, 0],
                  ],
                  o: [
                    [4.011, 3.137],
                    [0, 8.021],
                    [-8.013, 0],
                    [-9.412, 0],
                    [0, 17.263],
                    [4.181, 0],
                    [0, -2.434],
                    [-6.444, 0],
                    [0, -10.988],
                    [0, 0],
                    [19.527, 0],
                    [0, 25.455],
                    [-25.981, 0],
                    [0, -41.141],
                    [15.346, 0],
                  ],
                  v: [
                    [37.83, -48.904],
                    [44.452, -35.304],
                    [28.935, -19.617],
                    [7.492, -25.544],
                    [-14.122, 0.606],
                    [7.847, 27.104],
                    [15.69, 21.872],
                    [10.281, 18.387],
                    [-4.71, 3.921],
                    [13.597, -11.943],
                    [19.176, -11.943],
                    [48.463, 15.427],
                    [3.837, 58.315],
                    [-48.463, 0.606],
                    [4.88, -58.316],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [365.817, 277.092],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 8.894],
                    [8.369, 0],
                    [0, 0],
                    [0, 2.264],
                    [0, 0],
                    [-2.967, 0],
                    [0, 0],
                    [0, 10.456],
                    [9.76, 0],
                    [0, 0],
                    [0, -10.811],
                    [0, 0],
                    [-13.771, 0],
                    [0, 0],
                    [0, 10.463],
                    [9.76, 0],
                    [0, 0],
                    [0, 2.264],
                    [0, 0],
                    [-2.967, 0],
                  ],
                  o: [
                    [8.369, 0],
                    [0, -8.887],
                    [0, 0],
                    [-2.967, 0],
                    [0, 0],
                    [0, -2.272],
                    [0, 0],
                    [9.76, 0],
                    [0, -10.285],
                    [0, 0],
                    [-13.771, 0],
                    [0, 0],
                    [0, 10.803],
                    [0, 0],
                    [9.76, 0],
                    [0, -10.285],
                    [0, 0],
                    [-2.967, 0],
                    [0, 0],
                    [0, -2.265],
                    [0, 0],
                  ],
                  v: [
                    [14.296, 13.685],
                    [29.295, -0.263],
                    [14.296, -14.203],
                    [2.272, -14.203],
                    [-2.094, -18.214],
                    [-2.094, -21.004],
                    [2.272, -25.013],
                    [17.959, -25.013],
                    [35.393, -41.227],
                    [17.959, -57.268],
                    [-14.991, -57.268],
                    [-35.392, -38.436],
                    [-35.392, 38.444],
                    [-14.991, 57.268],
                    [17.959, 57.268],
                    [35.393, 41.056],
                    [17.959, 25.022],
                    [2.272, 25.022],
                    [-2.094, 21.012],
                    [-2.094, 17.697],
                    [2.272, 13.685],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [457.863, 277.088],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-28.237, 0],
                    [0, 21.274],
                    [0, 0],
                    [11.159, 0],
                    [0, -10.463],
                    [0, 0],
                    [6.281, 0],
                    [0, 4.188],
                    [0, 0],
                    [11.158, 0],
                    [0, -10.463],
                    [0, 0],
                  ],
                  o: [
                    [28.243, 0],
                    [0, 0],
                    [0, -10.463],
                    [-11.159, 0],
                    [0, 0],
                    [0, 4.188],
                    [-6.275, 0],
                    [0, 0],
                    [0, -10.463],
                    [-11.151, 0],
                    [0, 0],
                    [0, 21.274],
                  ],
                  v: [
                    [-0.091, 57.879],
                    [43.15, 19.697],
                    [43.15, -39.047],
                    [25.887, -57.879],
                    [8.633, -39.047],
                    [8.633, 17.781],
                    [-0.091, 26.845],
                    [-8.46, 17.781],
                    [-8.46, -39.047],
                    [-25.895, -57.879],
                    [-43.15, -39.047],
                    [-43.15, 19.697],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [176.403, 277.351],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 7',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 300.00001221925,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'Text King',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 31,
              s: [0],
            },
            {
              t: 32.0000013033867,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 32,
              s: [490, 39, 0],
              to: [0, 42.333, 0],
              ti: [0, -42.333, 0],
            },
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 35,
              s: [490, 293, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: {
                x: 0.833,
                y: 0.833,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 39,
              s: [490, 293, 0],
              to: [0, -2.333, 0],
              ti: [0, 2.333, 0],
            },
            {
              t: 45.0000018328876,
              s: [490, 279, 0],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [319, 334, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [53, 53, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 32,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [19.527, 0],
                          [0, -18.306],
                          [0, 0],
                          [-19.528, 0],
                          [0, 18.299],
                        ],
                        o: [
                          [0, -18.306],
                          [-19.528, 0],
                          [0, 0],
                          [0, 18.299],
                          [19.527, 0],
                          [0, 0],
                        ],
                        v: [
                          [30.161, -37.454],
                          [0.001, -70.404],
                          [-30.16, -37.454],
                          [-30.161, 32.736],
                          [0, 65.687],
                          [30.16, 32.736],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 35.0000014255792,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [19.527, 0],
                          [0, -18.306],
                          [0, 0],
                          [-19.528, 0],
                          [0, 18.299],
                        ],
                        o: [
                          [0, -18.306],
                          [-19.528, 0],
                          [0, 0],
                          [0, 18.299],
                          [19.527, 0],
                          [0, 0],
                        ],
                        v: [
                          [30.16, -51.604],
                          [0, -84.554],
                          [-30.161, -51.604],
                          [-30.161, 51.604],
                          [0, 84.554],
                          [30.16, 51.604],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [231.753, 429.895],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 32,
                    s: [
                      {
                        i: [
                          [0, 17.085],
                          [0, 0],
                          [-2.094, 0],
                          [-0.695, -1.392],
                          [-10.811, -12.032],
                          [-9.59, 0],
                          [0, 15.169],
                          [7.673, 8.362],
                          [4.187, 6.445],
                          [0, 0.695],
                          [-2.094, 1.917],
                          [-6.63, 10.286],
                          [0, 5.927],
                          [14.991, 0],
                          [6.105, -9.938],
                          [6.274, -6.104],
                          [1.214, 0],
                          [0, 2.264],
                          [0, 0],
                          [18.306, 0],
                          [0, -17.086],
                          [0, 0],
                          [-18.477, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, -2.086],
                          [2.79, 0],
                          [4.011, 9.589],
                          [7.325, 8.021],
                          [16.212, 0],
                          [0, -9.413],
                          [-9.768, -10.64],
                          [-1.57, -2.442],
                          [0, -1.924],
                          [4.884, -4.536],
                          [5.055, -7.843],
                          [0, -15.169],
                          [-9.59, 0],
                          [-8.191, 13.253],
                          [-1.569, 1.569],
                          [-2.094, 0],
                          [0, 0],
                          [0, -17.086],
                          [-18.477, 0],
                          [0, 0],
                          [0, 17.085],
                          [18.306, 0],
                        ],
                        v: [
                          [-16.301, 44.261],
                          [-16.301, 28.935],
                          [-13.335, 25.281],
                          [-9.155, 29.462],
                          [17.344, 62.042],
                          [43.324, 75.117],
                          [73.13, 45.83],
                          [61.452, 30.511],
                          [35.999, -0.521],
                          [34.26, -5.228],
                          [37.396, -10.46],
                          [59.99, -27.647],
                          [68.074, -48.094],
                          [39.312, -70.871],
                          [14.553, -55.532],
                          [-9.672, -25.082],
                          [-13.335, -23.165],
                          [-16.302, -26.828],
                          [-16.301, -42.845],
                          [-44.715, -73.701],
                          [-73.13, -42.845],
                          [-73.13, 44.261],
                          [-44.715, 75.117],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 35.0000014255792,
                    s: [
                      {
                        i: [
                          [0, 17.085],
                          [0, 0],
                          [-2.094, 0],
                          [-0.695, -1.392],
                          [-10.811, -12.032],
                          [-9.59, 0],
                          [0, 15.169],
                          [7.673, 8.362],
                          [4.187, 6.445],
                          [0, 0.695],
                          [-2.094, 1.917],
                          [-6.63, 10.286],
                          [0, 5.927],
                          [14.991, 0],
                          [6.105, -9.938],
                          [6.274, -6.104],
                          [1.214, 0],
                          [0, 2.264],
                          [0, 0],
                          [18.306, 0],
                          [0, -17.086],
                          [0, 0],
                          [-18.477, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, -2.086],
                          [2.79, 0],
                          [4.011, 9.589],
                          [7.325, 8.021],
                          [16.212, 0],
                          [0, -9.413],
                          [-9.768, -10.64],
                          [-1.57, -2.442],
                          [0, -1.924],
                          [4.884, -4.536],
                          [5.055, -7.843],
                          [0, -15.169],
                          [-9.59, 0],
                          [-8.191, 13.253],
                          [-1.569, 1.569],
                          [-2.094, 0],
                          [0, 0],
                          [0, -17.086],
                          [-18.477, 0],
                          [0, 0],
                          [0, 17.085],
                          [18.306, 0],
                        ],
                        v: [
                          [-16.301, 53.694],
                          [-16.301, 28.935],
                          [-13.335, 25.281],
                          [-9.155, 29.461],
                          [17.344, 71.475],
                          [43.324, 84.55],
                          [73.13, 55.263],
                          [61.452, 30.511],
                          [35.999, -0.521],
                          [34.26, -5.228],
                          [37.396, -10.46],
                          [60.933, -36.609],
                          [68.075, -57.527],
                          [39.312, -84.551],
                          [14.553, -69.211],
                          [-9.672, -34.516],
                          [-13.335, -32.599],
                          [-16.301, -36.262],
                          [-16.301, -53.694],
                          [-44.715, -84.551],
                          [-73.13, -53.694],
                          [-73.13, 53.694],
                          [-44.715, 84.55],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [116.257, 429.893],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 32,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [-1.917, 0],
                          [-1.221, -2.442],
                          [0, 0],
                          [-10.633, 0],
                          [0, 17.255],
                          [0, 0],
                          [17.958, 0],
                          [0, -16.916],
                          [0, 0],
                          [1.924, 0],
                          [1.221, 2.442],
                          [0, 0],
                          [10.988, 0],
                          [0, -17.263],
                          [0, 0],
                          [-17.959, 0],
                          [0, 16.908],
                        ],
                        o: [
                          [0, -3.137],
                          [1.398, 0],
                          [0, 0],
                          [9.243, 17.959],
                          [18.307, 0],
                          [0, 0],
                          [0, -16.916],
                          [-17.959, 0],
                          [0, 0],
                          [0, 3.137],
                          [-1.391, 0],
                          [0, 0],
                          [-9.242, -17.951],
                          [-18.299, 0],
                          [0, 0],
                          [0, 16.908],
                          [17.958, 0],
                          [0, 0],
                        ],
                        v: [
                          [-16.822, 16.563],
                          [-13.862, 12.028],
                          [-10.2, 15.343],
                          [14.033, 43.543],
                          [43.846, 65.683],
                          [72.26, 34.657],
                          [72.26, -40.062],
                          [44.542, -70.4],
                          [16.824, -40.062],
                          [16.824, -16.557],
                          [13.856, -12.029],
                          [10.2, -15.344],
                          [-14.033, -48.261],
                          [-43.845, -70.4],
                          [-72.26, -39.367],
                          [-72.26, 35.352],
                          [-44.541, 65.683],
                          [-16.822, 35.352],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 35.0000014255792,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [-1.917, 0],
                          [-1.221, -2.442],
                          [0, 0],
                          [-10.633, 0],
                          [0, 17.255],
                          [0, 0],
                          [17.958, 0],
                          [0, -16.916],
                          [0, 0],
                          [1.924, 0],
                          [1.221, 2.442],
                          [0, 0],
                          [10.988, 0],
                          [0, -17.263],
                          [0, 0],
                          [-17.959, 0],
                          [0, 16.908],
                        ],
                        o: [
                          [0, -3.137],
                          [1.398, 0],
                          [0, 0],
                          [9.243, 17.959],
                          [18.307, 0],
                          [0, 0],
                          [0, -16.916],
                          [-17.959, 0],
                          [0, 0],
                          [0, 3.137],
                          [-1.391, 0],
                          [0, 0],
                          [-9.242, -17.951],
                          [-18.299, 0],
                          [0, 0],
                          [0, 16.908],
                          [17.958, 0],
                          [0, 0],
                        ],
                        v: [
                          [-16.822, 16.564],
                          [-13.862, 12.028],
                          [-10.2, 15.343],
                          [14.033, 62.411],
                          [43.846, 84.55],
                          [72.26, 53.525],
                          [72.26, -54.212],
                          [44.542, -84.55],
                          [16.824, -54.212],
                          [16.824, -16.556],
                          [13.856, -12.029],
                          [10.2, -15.344],
                          [-14.033, -62.411],
                          [-43.845, -84.55],
                          [-72.26, -53.517],
                          [-72.26, 54.22],
                          [-44.541, 84.55],
                          [-16.822, 54.22],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [354.396, 429.891],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 32,
                    s: [
                      {
                        i: [
                          [-10.634, -7.843],
                          [0, -8.54],
                          [13.941, 0],
                          [17.256, 0],
                          [0, -27.719],
                          [-19.697, 0],
                          [0, 4.536],
                          [4.706, 0],
                          [0, 14.295],
                          [-15.339, 0],
                          [0, 0],
                          [0, -23.36],
                          [40.971, 0],
                          [-0.504, 47.75],
                          [-40.623, 0],
                        ],
                        o: [
                          [6.104, 4.536],
                          [0, 11.506],
                          [-12.032, 0],
                          [-14.126, 0],
                          [0, 24.928],
                          [5.927, 0],
                          [0, -3.655],
                          [-9.59, 0],
                          [0, -15.687],
                          [0, 0],
                          [29.457, 0],
                          [0, 36.961],
                          [-39.047, 0],
                          [0.63, -59.615],
                          [22.657, 0],
                        ],
                        v: [
                          [56.747, -61.432],
                          [66.685, -41.734],
                          [43.324, -28.326],
                          [11.247, -37.042],
                          [-21.185, 0.784],
                          [11.942, 34.419],
                          [23.449, 26.923],
                          [15.428, 21.87],
                          [-7.06, 5.49],
                          [20.134, -17.344],
                          [28.681, -17.344],
                          [72.781, 22.227],
                          [5.838, 66.069],
                          [-72.782, 0.784],
                          [7.414, -75.032],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 35.0000014255792,
                    s: [
                      {
                        i: [
                          [-10.634, -7.843],
                          [0, -8.54],
                          [13.941, 0],
                          [17.256, 0],
                          [0, -27.719],
                          [-19.697, 0],
                          [0, 4.536],
                          [4.706, 0],
                          [0, 14.295],
                          [-15.339, 0],
                          [0, 0],
                          [0, -23.36],
                          [40.971, 0],
                          [0, 57.005],
                          [-40.623, 0],
                        ],
                        o: [
                          [6.104, 4.536],
                          [0, 11.506],
                          [-12.032, 0],
                          [-14.126, 0],
                          [0, 24.928],
                          [5.927, 0],
                          [0, -3.655],
                          [-9.59, 0],
                          [0, -15.687],
                          [0, 0],
                          [29.457, 0],
                          [0, 36.961],
                          [-39.047, 0],
                          [0, -59.618],
                          [22.657, 0],
                        ],
                        v: [
                          [56.747, -70.866],
                          [66.685, -51.167],
                          [43.324, -28.326],
                          [11.247, -37.042],
                          [-21.185, 0.784],
                          [11.942, 39.135],
                          [23.449, 31.639],
                          [15.428, 26.586],
                          [-7.06, 5.49],
                          [20.134, -17.344],
                          [28.681, -17.344],
                          [72.781, 22.227],
                          [5.838, 84.465],
                          [-72.782, 0.784],
                          [7.414, -84.465],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.839215686275, 0.141176470588, 0, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [513.041, 429.805],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 300.00001221925,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: 'Bun Top',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 34,
              s: [0],
            },
            {
              t: 35.0000014255792,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [490, 278, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [319, 334, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [53, 53, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 35,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 9.413],
                          [186.017, 0],
                          [0, -55.785],
                          [-10.109, 0],
                        ],
                        o: [
                          [10.115, 0],
                          [0, -55.785],
                          [-187.755, 0],
                          [0, 9.413],
                          [0, 0],
                        ],
                        v: [
                          [256.97, -92.893],
                          [271.614, -107.537],
                          [-0.001, -272.201],
                          [-271.614, -107.537],
                          [-256.97, -92.893],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 40,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 9.413],
                          [186.017, 0],
                          [0, -55.785],
                          [-10.109, 0],
                        ],
                        o: [
                          [10.115, 0],
                          [0, -55.785],
                          [-187.755, 0],
                          [0, 9.413],
                          [0, 0],
                        ],
                        v: [
                          [256.97, 115.598],
                          [271.614, 100.954],
                          [-0.001, -40.126],
                          [-271.614, 100.954],
                          [-256.97, 115.598],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 42,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 9.413],
                          [186.017, 0],
                          [0, -55.785],
                          [-10.109, 0],
                        ],
                        o: [
                          [10.115, 0],
                          [0, -55.785],
                          [-187.755, 0],
                          [0, 9.413],
                          [0, 0],
                        ],
                        v: [
                          [256.97, 92.013],
                          [271.614, 77.369],
                          [-0.001, -69.371],
                          [-271.614, 77.369],
                          [-256.97, 92.013],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 43,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 9.413],
                          [186.017, 0],
                          [0, -55.785],
                          [-10.109, 0],
                        ],
                        o: [
                          [10.115, 0],
                          [0, -55.785],
                          [-187.755, 0],
                          [0, 9.413],
                          [0, 0],
                        ],
                        v: [
                          [256.97, 92.013],
                          [271.614, 77.369],
                          [-0.001, -69.371],
                          [-271.614, 77.369],
                          [-256.97, 92.013],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 44.0000017921567,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, 9.413],
                          [186.017, 0],
                          [0, -55.785],
                          [-10.109, 0],
                        ],
                        o: [
                          [10.115, 0],
                          [0, -55.785],
                          [-187.755, 0],
                          [0, 9.413],
                          [0, 0],
                        ],
                        v: [
                          [256.97, 84.465],
                          [271.614, 69.822],
                          [-0.001, -84.465],
                          [-271.614, 69.822],
                          [-256.97, 84.465],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.509803921569, 0.2, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [314.386, 114.783],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 8',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 300.00001221925,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: 'Bun Bottom',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.833],
                y: [0.833],
              },
              o: {
                x: [0.167],
                y: [0.167],
              },
              t: 8,
              s: [0],
            },
            {
              t: 9.00000036657752,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [490, 279, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [319, 334, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [53, 53, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 9,
                    s: [
                      {
                        i: [
                          [23.613, -14.653],
                          [0, -8.539],
                          [-18.808, -16.064],
                          [-43.788, 0.484],
                          [-20.66, 14.125],
                          [0, 14.991],
                          [17.741, 20.724],
                          [25.735, -0.502],
                        ],
                        o: [
                          [-23.613, 14.653],
                          [0, 14.991],
                          [20.843, 17.802],
                          [38.757, -0.429],
                          [25.778, -17.624],
                          [0, -8.539],
                          [-17.741, -20.724],
                          [-25.735, 0.502],
                        ],
                        v: [
                          [-67.347, -159.663],
                          [-99.444, -110.391],
                          [-81.586, -59.136],
                          [9.434, -26.186],
                          [79.7, -46.4],
                          [115.482, -104.259],
                          [97.536, -149.286],
                          [9.303, -183.248],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 10,
                    s: [
                      {
                        i: [
                          [15.742, -9.769],
                          [0, -8.539],
                          [-21.603, -15.822],
                          [-65.047, 0.323],
                          [-28.88, 17.958],
                          [0, 14.991],
                          [15.2, 13.816],
                          [17.156, -0.335],
                        ],
                        o: [
                          [-19.111, 9.769],
                          [0, 14.991],
                          [29.005, 20.409],
                          [61.694, -0.286],
                          [26.252, -16.863],
                          [0, -8.539],
                          [-11.828, -13.816],
                          [-17.156, 0.335],
                        ],
                        v: [
                          [-116.404, -256.676],
                          [-155.891, -223.127],
                          [-131.272, -174.702],
                          [6.289, -143.009],
                          [128.756, -166.84],
                          [167.211, -221.555],
                          [144.077, -251.645],
                          [4.586, -279.003],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 12,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [0, 0],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-256.97, -443.154],
                          [-271.614, -429.731],
                          [-230.643, -378.475],
                          [0, -345.525],
                          [230.643, -378.475],
                          [271.614, -429.731],
                          [256.97, -443.154],
                          [-4.848, -443.154],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.667,
                      y: 1,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 13,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [0, 0],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-256.97, -443.154],
                          [-271.614, -429.731],
                          [-230.643, -378.475],
                          [0, -345.525],
                          [230.643, -378.475],
                          [271.614, -429.731],
                          [256.97, -443.154],
                          [-4.848, -443.154],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.794,
                      y: 0,
                    },
                    t: 14,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [85.169, 0.441],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [-85.169, -0.441],
                        ],
                        v: [
                          [-256.97, -495.984],
                          [-271.614, -482.561],
                          [-230.643, -431.305],
                          [0, -420.997],
                          [230.643, -431.305],
                          [271.614, -482.561],
                          [256.97, -495.984],
                          [-4.848, -518.626],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.62,
                      y: 1,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 15,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [119.131, -2.48],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [-119.131, 2.48],
                        ],
                        v: [
                          [-256.97, -502.596],
                          [-271.614, -489.173],
                          [-230.643, -437.917],
                          [0, -425.805],
                          [230.643, -437.917],
                          [271.614, -489.173],
                          [256.97, -502.596],
                          [-4.848, -523.434],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.699,
                      y: 0,
                    },
                    t: 17,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [0, 0],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-256.97, -579.003],
                          [-271.614, -565.58],
                          [-230.643, -514.324],
                          [0, -481.374],
                          [230.643, -514.324],
                          [271.614, -565.58],
                          [256.97, -579.003],
                          [-4.848, -579.003],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 26,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-22.369, -20.133],
                          [-134.969, -0.263],
                          [-32.928, 22.744],
                          [0, 14.991],
                          [10.116, 0],
                          [117.036, -2.676],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [28.557, 23.642],
                          [124.267, 0.234],
                          [26.745, -19.235],
                          [0, -8.539],
                          [0, 0],
                          [-117.036, 2.676],
                        ],
                        v: [
                          [-256.97, -344.065],
                          [-271.614, -330.642],
                          [-230.643, -259.497],
                          [0, -194.227],
                          [231.886, -259.807],
                          [272.857, -333.749],
                          [258.213, -347.172],
                          [-3.17, -319.856],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 28,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-19.872, -22.616],
                          [-149.16, -0.399],
                          [-26.51, 21.252],
                          [0, 14.991],
                          [10.116, 0],
                          [82.056, 0.394],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [19.872, 22.616],
                          [132.916, 0.356],
                          [26.51, -21.252],
                          [0, -8.539],
                          [0, 0],
                          [-82.056, -0.394],
                        ],
                        v: [
                          [-256.97, -222.399],
                          [-271.614, -208.976],
                          [-230.643, -127.532],
                          [0, -45.525],
                          [232.53, -128.003],
                          [273.501, -213.693],
                          [258.857, -227.116],
                          [-2.301, -185.654],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 29,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-23.532, -18.977],
                          [-128.363, -0.2],
                          [-35.916, 23.439],
                          [0, 14.991],
                          [10.116, 0],
                          [92.388, 1.833],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [32.6, 24.12],
                          [120.241, 0.178],
                          [26.855, -18.296],
                          [0, -8.539],
                          [0, 0],
                          [-92.388, -1.833],
                        ],
                        v: [
                          [-266.404, -124.286],
                          [-281.048, -110.863],
                          [-240.077, -53.003],
                          [0, 1.645],
                          [241.964, -53.239],
                          [282.935, -113.222],
                          [268.291, -126.645],
                          [-3.289, -105.914],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 30,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-43.946, -1.93],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [0, 0],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [43.946, 1.93],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-275.838, -26.173],
                          [-290.482, -12.75],
                          [-249.511, 21.525],
                          [0, 58.249],
                          [251.398, 21.525],
                          [292.369, -12.75],
                          [277.725, -26.173],
                          [-4.278, -26.173],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 33,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [0, 0],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-250.681, -26.173],
                          [-265.325, -12.75],
                          [-224.354, 21.525],
                          [0, 58.248],
                          [225.612, 21.525],
                          [266.583, -12.75],
                          [251.939, -26.173],
                          [-4.112, -26.173],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    i: {
                      x: 0.833,
                      y: 0.833,
                    },
                    o: {
                      x: 0.167,
                      y: 0.167,
                    },
                    t: 39,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [0, 0],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-256.97, -26.173],
                          [-271.614, -12.75],
                          [-230.643, 21.525],
                          [0, 60.135],
                          [230.643, 21.525],
                          [271.614, -12.75],
                          [256.97, -26.173],
                          [-4.848, -26.173],
                        ],
                        c: true,
                      },
                    ],
                  },
                  {
                    t: 44.0000017921567,
                    s: [
                      {
                        i: [
                          [0, 0],
                          [0, -8.539],
                          [-27.193, -15.339],
                          [-107.567, 0],
                          [-45.322, 25.625],
                          [0, 14.991],
                          [10.116, 0],
                          [0, 0],
                        ],
                        o: [
                          [-10.108, 0],
                          [0, 14.991],
                          [45.329, 25.625],
                          [107.567, 0],
                          [27.2, -15.339],
                          [0, -8.539],
                          [0, 0],
                          [0, 0],
                        ],
                        v: [
                          [-256.97, -48.814],
                          [-271.614, -35.391],
                          [-230.643, 15.865],
                          [0, 48.815],
                          [230.643, 15.865],
                          [271.614, -35.391],
                          [256.97, -48.814],
                          [-4.848, -48.814],
                        ],
                        c: true,
                      },
                    ],
                  },
                ],
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 0.509803921569, 0.2, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [314.677, 581.369],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 9',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 300.00001221925,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
  chars: [
    {
      ch: '®',
      size: 14,
      style: 'Condensed',
      w: 80.8,
      data: {
        shapes: [
          {
            ty: 'gr',
            it: [
              {
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 20.142],
                      [0, 0],
                      [20.041, 0],
                      [0, -19.94],
                      [-20.041, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -19.839],
                      [-20.041, 0],
                      [0, 20.142],
                      [19.94, 0],
                    ],
                    v: [
                      [76.538, -35.349],
                      [76.538, -35.852],
                      [40.686, -71.402],
                      [4.834, -35.751],
                      [40.686, 0.302],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: '®',
                mn: 'ADBE Vector Shape - Group',
                hd: false,
              },
              {
                ind: 1,
                ty: 'sh',
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, -18.329],
                      [18.027, 0],
                      [0, 18.027],
                      [-18.329, 0],
                    ],
                    o: [
                      [0, 17.926],
                      [-18.027, 0],
                      [0, -18.228],
                      [18.127, 0],
                    ],
                    v: [
                      [73.315, -35.349],
                      [40.585, -2.921],
                      [8.057, -35.55],
                      [40.887, -68.179],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: '®',
                mn: 'ADBE Vector Shape - Group',
                hd: false,
              },
              {
                ind: 2,
                ty: 'sh',
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 1.007],
                      [0.705, 1.007],
                      [1.007, 1.712],
                      [0.403, 0.604],
                      [0.101, 0.101],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.201, 0.302],
                      [0.302, 0.403],
                      [0.101, 0.201],
                      [0, 0],
                      [0, 0.201],
                      [-0.604, 0.403],
                      [0, 4.23],
                      [0.101, 0.604],
                      [0, 0],
                      [0.604, 1.309],
                      [0.403, 0.604],
                      [0, 0.101],
                      [0.101, 0.101],
                      [0.101, 0.101],
                      [0.101, 0.101],
                      [0.101, 0.101],
                      [1.611, 0.705],
                      [3.525, 0.302],
                      [0.604, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -2.216],
                      [-0.101, -0.403],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.101, -1.511],
                      [0, -0.504],
                      [0, -0.504],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -0.403],
                      [0, -1.108],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -0.403],
                      [0, 0],
                      [0, -0.302],
                      [-1.309, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.906, 0],
                      [-0.403, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 1.108],
                      [0, 0],
                      [0, 0],
                      [0, 1.309],
                      [0, 0],
                      [0, 0.906],
                      [0, 0.201],
                      [0, 1.007],
                      [0, 0.403],
                      [-0.705, 0],
                      [-0.504, -1.007],
                      [0, -0.101],
                      [0, 0],
                      [-0.101, -0.101],
                      [-0.201, -0.504],
                      [-0.302, -0.504],
                      [0, 0],
                      [0, 0],
                      [-0.201, -0.201],
                      [-0.101, -0.201],
                      [0, 0],
                      [0, 0],
                      [-1.712, 0],
                      [-0.705, 0.101],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.906, -0.101],
                      [-0.504, 0],
                    ],
                    o: [
                      [0, -0.604],
                      [-0.201, -0.201],
                      [-0.302, -0.604],
                      [0, -0.101],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.101, -0.201],
                      [-0.504, -0.806],
                      [-0.806, -1.108],
                      [0, 0],
                      [-0.302, -0.604],
                      [0, -0.302],
                      [3.625, -2.216],
                      [0, -0.302],
                      [0, 0],
                      [0, -2.719],
                      [-0.201, -0.403],
                      [0, -0.101],
                      [-0.201, -0.302],
                      [-0.201, -0.504],
                      [-0.101, -0.101],
                      [-0.101, -0.101],
                      [-1.511, -1.712],
                      [-2.014, -0.906],
                      [-0.705, -0.101],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-3.525, 0],
                      [0, 0.302],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.705],
                      [0, 1.41],
                      [0, 0.302],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.201],
                      [0.101, 2.216],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.101],
                      [0, 0],
                      [0, 0.403],
                      [0, 1.108],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.302, 0],
                      [0.806, -0.101],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.309, 0],
                      [0, 0],
                      [0, 0],
                      [-0.101, -0.302],
                      [0, 0],
                      [0, -0.403],
                      [0, -0.504],
                      [0, -0.302],
                      [-0.101, -0.604],
                      [0, -1.108],
                      [0.504, 0],
                      [0.101, 0.101],
                      [0, 0],
                      [0, 0.201],
                      [0, 0.101],
                      [0.403, 0.705],
                      [0, 0],
                      [0, 0],
                      [0.101, 0.101],
                      [0.101, 0.201],
                      [0, 0],
                      [0, 0],
                      [0.806, 2.115],
                      [0.302, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.504, 0],
                      [0.504, 0],
                      [1.611, 0],
                    ],
                    v: [
                      [61.13, -14.502],
                      [60.223, -16.718],
                      [58.511, -19.638],
                      [57.404, -21.451],
                      [57.303, -21.652],
                      [57.001, -22.256],
                      [56.699, -22.861],
                      [56.296, -23.465],
                      [55.893, -24.17],
                      [54.785, -25.983],
                      [53.476, -27.896],
                      [53.073, -28.601],
                      [52.57, -29.91],
                      [53.375, -30.917],
                      [59.821, -42.398],
                      [59.72, -43.707],
                      [59.72, -44.211],
                      [58.713, -50.354],
                      [58.008, -51.764],
                      [57.907, -52.066],
                      [57.504, -52.67],
                      [57.001, -53.577],
                      [56.799, -53.778],
                      [56.497, -54.08],
                      [52.167, -57.404],
                      [45.117, -59.015],
                      [43.304, -59.116],
                      [42.197, -59.116],
                      [41.693, -59.116],
                      [41.19, -59.116],
                      [39.78, -59.116],
                      [38.37, -59.015],
                      [35.046, -58.914],
                      [33.939, -58.914],
                      [32.428, -58.914],
                      [30.817, -58.914],
                      [30.112, -59.015],
                      [29.608, -59.015],
                      [29.105, -59.015],
                      [27.896, -59.015],
                      [22.961, -55.893],
                      [23.062, -54.684],
                      [23.062, -53.577],
                      [23.163, -53.174],
                      [23.163, -52.469],
                      [23.163, -51.764],
                      [23.163, -51.562],
                      [22.961, -47.232],
                      [22.961, -45.721],
                      [23.062, -43.002],
                      [23.163, -40.182],
                      [23.062, -38.974],
                      [23.062, -37.061],
                      [22.961, -35.248],
                      [22.961, -33.939],
                      [22.861, -32.529],
                      [22.861, -30.011],
                      [22.861, -29.205],
                      [22.961, -28.601],
                      [22.961, -27.997],
                      [22.961, -27.09],
                      [23.062, -26.083],
                      [23.163, -21.954],
                      [23.163, -19.739],
                      [23.062, -18.53],
                      [23.062, -17.725],
                      [22.961, -16.919],
                      [22.861, -16.113],
                      [22.76, -15.005],
                      [25.278, -12.891],
                      [25.378, -12.891],
                      [26.486, -12.891],
                      [27.493, -12.891],
                      [29.004, -12.991],
                      [30.917, -13.092],
                      [31.018, -13.092],
                      [31.824, -13.092],
                      [33.838, -13.092],
                      [34.644, -12.991],
                      [35.449, -12.991],
                      [37.564, -14.703],
                      [37.564, -15.005],
                      [37.463, -15.912],
                      [37.262, -18.329],
                      [37.262, -18.732],
                      [37.363, -20.544],
                      [37.463, -21.652],
                      [37.363, -23.566],
                      [37.262, -25.177],
                      [38.37, -26.99],
                      [39.981, -25.378],
                      [40.082, -25.177],
                      [40.384, -24.774],
                      [40.585, -24.371],
                      [40.887, -23.566],
                      [42.096, -21.451],
                      [42.7, -20.444],
                      [44.312, -17.322],
                      [44.614, -16.919],
                      [44.916, -16.315],
                      [45.117, -15.811],
                      [45.319, -15.308],
                      [48.541, -12.891],
                      [49.85, -12.991],
                      [50.656, -12.991],
                      [51.059, -12.991],
                      [52.066, -13.092],
                      [53.174, -13.092],
                      [54.282, -13.092],
                      [55.087, -13.092],
                      [55.188, -13.092],
                      [57.303, -12.991],
                      [58.713, -12.891],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: '®',
                mn: 'ADBE Vector Shape - Group',
                hd: false,
              },
              {
                ind: 3,
                ty: 'sh',
                ix: 4,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.101, -0.302],
                      [2.618, 0],
                      [0, 1.511],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.201],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.014, 0],
                      [0, -2.618],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0.101],
                      [-0.302, 2.618],
                      [-1.913, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.101, -0.302],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -2.115],
                      [2.719, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [45.319, -42.499],
                      [45.218, -42.096],
                      [45.117, -41.492],
                      [40.787, -37.665],
                      [37.161, -40.485],
                      [37.161, -40.787],
                      [37.161, -40.988],
                      [37.161, -41.693],
                      [37.262, -42.499],
                      [37.262, -42.801],
                      [37.262, -43.405],
                      [37.262, -44.513],
                      [37.363, -44.916],
                      [37.363, -45.419],
                      [40.384, -48.541],
                      [45.319, -43.808],
                      [45.319, -43.707],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: '®',
                mn: 'ADBE Vector Shape - Group',
                hd: false,
              },
            ],
            nm: '®',
            np: 7,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false,
          },
        ],
      },
      fFamily: 'Block Pro',
    },
  ],
};
